<template>
  <el-table
    :data="tableData"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      v-for="item in tableColumnList"
      :key="item.prop"
      :prop="item.prop"
      :label="item.label"
      min-width="120"
      align="center"
    >
    </el-table-column>
    <el-table-column
      v-if="measureUnitId"
      prop="measureUnitSum"
      :label="measureUnitName + '数'"
      width="120"
      align="center"
    >
    </el-table-column>
  </el-table>
</template>

<script>
import Empty from "../../../components/empty.vue";
import mixins from "../../../mixins";
export default {
  mixins: [mixins],
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
  },
  data() {
    return {
      measureUnitId: "",
      measureUnitName: "",
      newMeasureUnitName: "",
      tableColumnList: [
        {
          prop: "authorId",
          label: "主播ID",
        },
        {
          prop: "authorName",
          label: "主播名称",
        },
        {
          prop: "saleAmount",
          label: "成交金额",
        },
        {
          prop: "buyerCount",
          label: "成交人数",
        },
        {
          prop: "orderCount",
          label: "成交单量",
        },
        {
          prop: "itemCount",
          label: "成交件数",
        },
        {
          prop: "customerUnitPrice",
          label: "客单价",
        },
        {
          prop: "orderUnitPrice",
          label: "笔单价",
        },
        {
          prop: "itemUnitPrice",
          label: "件单价",
        },
        {
          prop: "avgPurchaseFrequency",
          label: "人均购买频次",
        },
        {
          prop: "avgPurchaseItems",
          label: "人均购买件数",
        },
        {
          prop: "avgItemsPerOrder",
          label: "笔均购买件数",
        },
        {
          prop: "refundAmount",
          label: "退款金额",
        },
        {
          prop: "refundCount",
          label: "退款人数",
        },
        {
          prop: "refundOrderCount",
          label: "退款单量",
        },
        {
          prop: "refundRatioStr",
          label: "退款率",
        },
      ],
    };
  },
};
</script>

<style></style>
